import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  centered?: boolean;
}
export function SectionHeader({
  title,
  subtitle,
  eyebrow,
  centered = true
}: SectionHeaderProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`mb-8 md:mb-12 ${centered ? 'text-center' : 'text-left'}`} data-id="element-307">
      {eyebrow && <span className="inline-block text-[#E76F51] font-bold tracking-wider uppercase text-xs md:text-sm mb-2 md:mb-3" data-id="element-308">
          {eyebrow}
        </span>}
      <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-[#1E2A4A] mb-3 md:mb-4 leading-tight" data-id="element-309">
        {title}
      </h2>
      {subtitle && <p className="text-base md:text-xl text-[#1E2A4A]/80 max-w-3xl mx-auto" data-id="element-310">
          {subtitle}
        </p>}
    </motion.div>;
}